import { ActionTree } from 'vuex';
import moment from 'moment';
import { IBetaFlagState } from '@/beta-flag/store/beta-flag.types';
import { EBetaFlagAction, EBetaFlagMutation } from '@/beta-flag/store/beta-flag.constants';
import { RootState } from '@/store/store';
import { BetaFlagService } from '@/services/beta-flag.service';
import { translate } from '@/helpers/translation.helper';

export const actions: ActionTree<IBetaFlagState, RootState> = {
  async [EBetaFlagAction.FetchBetaFlags]({ state, commit }) {
    const expires: moment.Moment = moment(state.dismissedBetaExpires);
    try {
      const v3: number = await BetaFlagService.fetchBetaFlag('v3');
      const contentLinkBlock: number = await BetaFlagService.fetchBetaFlag('contentlinkblock');
      const videoBlock: number = await BetaFlagService.fetchBetaFlag('videoblock');
      const editorBlock: number = await BetaFlagService.fetchBetaFlag('editorblock');
      if (moment().isAfter(expires)) {
        commit(EBetaFlagMutation.SetDismissedBetaExpires, null);
      }
      const flags: {
        v3: number;
        contentLinkBlock: number;
        videoBlock: number;
        editorBlock: number;
      } = {
        v3,
        contentLinkBlock,
        videoBlock,
        editorBlock,
      };
      commit(EBetaFlagMutation.SetFlags, flags);
    } catch (e) {
      console.error(e);
    }
  },
  async [EBetaFlagAction.HandleBetaOptIn]({ commit, dispatch }, value: '1' | '0') {
    const dismissDays: number = 21;
    const dismissedBetaExpires: string = moment().add(dismissDays, 'days').toString();
    try {
      await BetaFlagService.setBetaFlag('v3', value);
      commit(EBetaFlagMutation.SetDismissedBetaExpires, dismissedBetaExpires);
      dispatch(EBetaFlagAction.FetchBetaFlags);
    } catch (e) {
      console.error(e);
      dispatch(
        'alert/showDangerAlert',
        translate('could-not-save-the-setting-try-refreshing-the-page'),
        {
          root: true,
        }
      );
    }
  },
};
